import { render } from "./Vaccum.vue?vue&type=template&id=1daa2366&scoped=true"
import script from "./Vaccum.vue?vue&type=script&lang=js"
export * from "./Vaccum.vue?vue&type=script&lang=js"

import "./Vaccum.vue?vue&type=style&index=0&id=1daa2366&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1daa2366"]])

export default __exports__